import AccountProfileSection from './sections/AccountProfileSection';
import AccountBusinessSection from './sections/AccountBusinessSection';
import AccountSecuritySection from './sections/AccountSecuritySection';
import AccountSaveAction from './sections/AccountSaveAction';

const AccountTab = () => {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-3xl border border-gray-100 shadow-sm space-y-6">
      {/* 1. Account Profile (Avatar, Email, Name, Phone) */}
      <AccountProfileSection />

      {/* 2. Business Details (Company Name, City, Pin, Address) */}
      <AccountBusinessSection />

      {/* 3. Account Security (Password Change & OTP Reset) */}
      <AccountSecuritySection />

      {/* 4. Save Profile Action */}
      <AccountSaveAction />
    </div>
  );
};

export default AccountTab;
